import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./Navbar_1.css";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDefaultSettings } from "../../../Redux/actions/defaultSettingsActions";
import {
  NotificationsIcon,
  BackArrowIcon2,
  New_ScrollX2025,
} from "../../../assets/icons/index";

import {
  deleteNotifications,
  getNotification,
  updateNotification,
} from "../../../Redux/actions/commonActtion";
import { DropdownForNotiFy } from "../../../Components";
import Setting from "../../Setting/Setting";

export default function Navbar_1() {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const project = useSelector((state) => state.project);

  const notifications = useSelector(
    (state) => state.commonReducer.notifications
  );
  const notificationsWithReadStatus = useSelector(
    (state) => state.commonReducer.notificationsWithReadStatus
  );
  let notificationsLentgh = notificationsWithReadStatus
    ? notificationsWithReadStatus.length
    : 0;

  useEffect(() => {
    fetchProjectSettings();
    dispatch(getNotification());
  }, []);

  const fetchProjectSettings = () => {
    dispatch(getDefaultSettings());
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );

  const getAllNotification = async () => {
    if (notificationsLentgh > 0) {
      await dispatch(updateNotification()).then(() => {
        notificationsLentgh = notificationsWithReadStatus.length;
      });
    }
    setIsOptionsVisible(true);
    dispatch(getNotification());
  };
  const fetchData = async (arg) => {};
  const handleDeleteNotification = async (id) => {
    dispatch(deleteNotifications({ notification_id: id }));
  };

  const getUserInitials = () => {
    const firstName = userInfo?.firstName?.trim() || "";
    // const lastName = userInfo?.lastName?.trim() || "";
    // if (firstName && lastName) {
    //   return `${firstName.charAt(0).toUpperCase()}${lastName
    //     .charAt(0)
    //     .toUpperCase()}`;
    // }
    if (firstName) {
      return `${firstName.charAt(0).toUpperCase()}`;
    }
    return "U";
  };

  const getBackgroundColor = () => {
    const initials = getUserInitials(); // Get initials
    const firstLetter = initials.charAt(0); // Extract first letter


    const colors = {
      A: "#413CAA",
      B: "#413CAA",
      C: "#413CAA",
      D: "#413CAA",
      E: "#413CAA",
      F: "#413CAA",
      G: "#413CAA",
      H: "#413CAA",
      I: "#413CAA",
      J: "#413CAA",
      K: "#413CAA",
      L: "#413CAA",
      M: "#413CAA",
      N: "#413CAA",
      O: "#413CAA",
      P: "#413CAA",
      Q: "#413CAA",
      R: "#413CAA",
      S: "#413CAA",
      T: "#413CAA",
      U: "#413CAA",
      V: "#413CAA",
      W: "#413CAA",
      X: "#413CAA",
      Y: "#413CAA",
      Z: "#413CAA",
    };

    return colors[firstLetter] || "#413CAA"; // Default color if not found
  };

  return (
    <>
      <ToastContainer closeButton={CloseButton} />
      <nav
        id="navbar_1"
        className="Pro_navbar w-full h-full  flex flex-wrap items-center justify-between text-slate-200 focus:text-sly-700 drop-shadow-2xl "
      >
        <div className="w-full h-full flex flex-wrap items-center justify-between px-[1%]">
          <div className="flex items-center w-[15%]">
            <Link className="flex items-center" to="/dashboard">
              <img
                className=" w-[11px] cursor-pointer"
                src={BackArrowIcon2}
                alt=""
              />
            </Link>

            <div className="flex items-center pl-[7%]">
              <img className="w-[35px] " src={New_ScrollX2025} />
              <span className="ml-[10px] Syne700 text-xl tracking-wide ">
                ScrollX.io
              </span>
            </div>
          </div>

          <div className="w-[55%] flex justify-center items-center">
            <h1 className="manrope-600 text-[15px] text-white font-light">
              {project?.title?.toUpperCase()}
            </h1>
          </div>

          <div className="flex justify-end w-[30%]">
            <div className="flex items-center">
              <div className="flex  mx-3  px-1 notification ">
                <button>
                  <img
                    className="pro_navabr_Notifications opacity-75"
                    src={NotificationsIcon}
                    onClick={getAllNotification}
                    alt=""
                  />
                </button>
                {notificationsLentgh > 0 && (
                  <button class="badge">{notificationsLentgh}</button>
                )}
              </div>

              <div className="flex m-auto">
                <button
                  className="w-[35px] h-[35px] rounded-full"
                  onClick={() => setIsSettingOpen(true)}
                  style={{ backgroundColor: getBackgroundColor() }}
                >
                  <div className="flex justify-center items-center text-white text-xl manrope-600 w-[35px] h-[35px] rounded-full ">
                    <span className="manrope-600 text-white text-xl text-center ">
                      {getUserInitials()}
                    </span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
      
      <Setting isSettingOpen={isSettingOpen} setIsSettingOpen={setIsSettingOpen}/>
      
      <DropdownForNotiFy
        isOptionsVisible={isOptionsVisible}
        setIsOptionsVisible={setIsOptionsVisible}
        options={notifications}
        notificationsLentgh={notificationsLentgh}
        fetchMoreData={fetchData}
        handleDeleteNotification={handleDeleteNotification}
      />
    </>
  );
}
